/* eslint-disable jsdoc/check-param-names */
import { Brick, registerBrick, BrickContext } from 'olympe';
import { getLogger } from '@olympeio/core';

export default class BuildCostObjectsRequestFilter extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} approvers
     * @param {*} costCenters
     * @param {*} personResponsibleIDPRN
     * @param {*} internalWBS
     * @param {*} wBSElements
     * @param {*} companyCodes
     * @param {*} plants
     * @param {*} purchasingOrganization
     * @param {*} purchasingGroups
     * @param {*} storageLocations
     * @param {*} releaseGroups
     * @param {*} releaseCodes
     * @param {*} positions
     * @param {function(string): void} setFilter
     */
    update(
        $,
        [
            approvers,
            costCenters,
            personResponsibleIDPRN,
            internalWBS,
            wBSElements,
            companyCodes,
            plants,
            purchasingOrganization,
            purchasingGroups,
            releaseGroups,
            releaseCodes,
            positions,
        ],
        [setFilter]
    ) {
        const logger = getLogger('BuildCostObjectsRequestPath');

        logger.debug('Building Cost Objects request path with');
        logger.debug('approvers', approvers);
        logger.debug('costCenters', costCenters);
        logger.debug('personResponsibleIDPRN', personResponsibleIDPRN);
        logger.debug('internalWBS', internalWBS);
        logger.debug('wBSElements', wBSElements);
        logger.debug('companyCodes', companyCodes);
        logger.debug('plants', plants);
        logger.debug('purchasingOrganization', purchasingOrganization);
        logger.debug('purchasingGroups', purchasingGroups);
        logger.debug('releaseGroups', releaseGroups);
        logger.debug('releaseCodes', releaseCodes);
        logger.debug('positions', positions);

        const paths = [];

        const addPath = (key, values) => {
            paths.push(`(${values.map((value) => `${key} eq '${value}'`).join(' or ')})`);
        };

        addPath('IdNo', ['01']);

        if (approvers?.length) {
            // TODO: Confirm
            addPath('AgentId', approvers);
        }

        if (positions?.length) {
            addPath('AgentId', positions);
        }

        if (costCenters?.length) {
            addPath('CostElementId', costCenters);
        }

        if (personResponsibleIDPRN?.length) {
            addPath('CostElementId', personResponsibleIDPRN);
        }

        if (internalWBS?.length) {
            addPath('CostElementId', internalWBS);
        }

        if (wBSElements?.length) {
            addPath('CostElementId', wBSElements);
        }

        if (companyCodes?.length) {
            addPath('CompanyCode', companyCodes);
        }

        if (plants?.length) {
            addPath('Plant', plants);
        }

        if (purchasingOrganization?.length) {
            addPath('PurchOrg', purchasingOrganization);
        }

        if (purchasingGroups?.length) {
            addPath('PurchGroup', purchasingGroups);
        }

        if (releaseGroups?.length) {
            addPath('RelGroup', releaseGroups);
        }

        if (releaseCodes?.length) {
            addPath('RelCode', releaseCodes);
        }

        const finalPath = paths.join(' and ');
        logger.debug('finalPath', finalPath);
        setFilter(finalPath);
    }
}

registerBrick('018c340da17a1f21c06e', BuildCostObjectsRequestFilter);
